import { render, staticRenderFns } from "./AircraftReportScreen.vue?vue&type=template&id=2494524f"
import script from "./AircraftReportScreen.vue?vue&type=script&lang=js"
export * from "./AircraftReportScreen.vue?vue&type=script&lang=js"
import style0 from "./AircraftReportScreen.vue?vue&type=style&index=0&id=2494524f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports